export const zIndex = {
  /**
   * Matching the Modal z-index for values defined in the Designer.
   *
   * @see packages/utilities/styled/zindex.js
   */
  modal: 10000,
  modalCloseButton: 10003, // Overlay system uses 10002
  modalNestedPortal: 10003, // Overlay system uses 10002
} as const;
